
import Vue, { PropType } from 'vue';

import {
  validatorTypes,
  ValidatorValueType,
} from '../../constants/validatorTypes';
import { mapState } from 'pinia';
import { useStore as useShapeStore } from '@/stores/shape';
import { CvToastNotification } from '@carbon/vue';

export default Vue.extend({
  name: 'OutOfBoundariesNotification',
  components: {
    CvToastNotification,
  },
  props: {
    collisionData: {
      type: Object as PropType<{
        data: boolean | undefined;
        payloadIds: string[];
      }>,
      required: true,
    },
  },
  computed: {
    ...mapState(useShapeStore, ['shapes']),
    type(): ValidatorValueType {
      return validatorTypes.collisionDetection;
    },
    artworksNames(): string {
      const result = [] as string[];
      this.collisionData.payloadIds.forEach((id) => {
        const shape = this.shapes.find((s) => s.id === id);
        const name = shape && shape.kind === 'Logo' ? shape.title : 'text';
        result.push(name);
      });

      return result.join(', ');
    },
  },
});
